/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.33"
        height="8.45"
        viewBox="0 0 19.33 8.45"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M18.82 2.95c.07-.2.15-.39.22-.56l.29-.73h-.78l-8.9.92-.74-2.62-4.94 2.2-.18 1.05-.58.06-.11-.66L2.73.42 0 .89l.37 2.22 1.75-.3.1.56-1.1.12.93 4.92h9.91c4.78.03 6.03-3.28 6.86-5.46Zm-17.62-1V1.7l.76-.13v.25Zm3.67.91 3.4-1.51.38 1.34-3.82.41Zm7.1 4.54H2.88l-.2-1.08 10.14-.81-.08-1-10.26.82-.18-1 1.34-.14 6.11-.65h.17l7.9-.83c-.81 2.13-1.89 4.67-5.86 4.67Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'BoatIcon';

export default Icon;
